// extracted by mini-css-extract-plugin
export default {"container":"articles-page_container__3ivJO","menuLabel":"articles-page_menuLabel__2RfxA","filters":"articles-page_filters__2ibq8"};